import { useGraphneAPI } from '@nexelem/graphne-api';
import { useQuery } from '@tanstack/react-query';

export const useGraphneProductionParametersList = (searchPhrase: string) => {
  const grapheApi = useGraphneAPI();

  return useQuery({
    queryKey: ['production-parameters-list', searchPhrase],
    queryFn: () => grapheApi.getGraphneInternalProductionParametersDictionary(),
  });
};
